const TYPE = "descontoProgressivo";

const descontoModule = {
  findAll: async (dbConnection, fields = null) => {
    let descontos = [];
    let query = {
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
      },
      //fields: ["_id", "idIntegracao", "desc", "cnpjCpf", "fantasia", "descFormat"],
      limit: 5,
    };

    if (fields) {
      query.fields = fields;
    }

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      descontos = result.docs;
    }

    return descontos;
  },

  findAllByDesc: async (dbConnection, desc) => {
    desc = desc.toUpperCase();
    let descontos = [];
    let query = {
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
        desc: { $regex: desc },
      },
      //fields: ["_id", "idIntegracao", "desc", "cnpjCpf", "fantasia", "descFormat"]
    };

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      descontos = result.docs;
    }

    return descontos;
  },

  findById: async (dbConnection, id) => {
    let desconto = null;
    let query = {
      selector: {
        idIntegracao: { $eq: id },
        type: { $eq: TYPE },
        status: { $eq: "A" },
      },
      limit: 1,
    };

    let result = await dbConnection.find(query);

    if (result.docs.length) {
      desconto = result.docs[0];
    }

    return desconto;
  },
};

export default descontoModule;
